import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TramiteSupersociedadesRoiDto} from '../dto/tramites/tramite-roi.dto';
import {TramiteResponseDTO} from '../dto/tramites/tramite.dto';
import {
  RespuestaEliminarDTO,
  TablaProfesionalesDTO
} from "../modules/tramites/supersociedades/liquidacion-judicial/models/liquidacion-judicial-DTO";
import {FormFieldOption} from "../dto/util/form-field";

@Injectable({
  providedIn: 'root'
})
export class TramiteSupersociedadesRoiService {

  private readonly apiUrl = environment.apiUrl;
  private readonly baseUrlSociedad = '/supersociedades/roi/sociedad';
  private readonly baseUrlSucursal = '/supersociedades/roi/sucursal';
  private readonly baseUrlPN = '/supersociedades/roi/pnc';
  private readonly baseUrlPNNC = '/supersociedades/roi/pnnc';
  private urlProfesionales = `${environment.apiUrl}/insolvencia`;

  constructor(private readonly http: HttpClient) {
  }

  crearTramiteSSRoiSociedad(
    data: TramiteSupersociedadesRoiDto
  ): Observable<TramiteResponseDTO> {
    return this.http.post<TramiteResponseDTO>(
      `${this.apiUrl}${this.baseUrlSociedad}`,
      data
    );
  }

  crearTramiteSSRoiSucursal(
    data: TramiteSupersociedadesRoiDto
  ): Observable<TramiteResponseDTO> {
    return this.http.post<TramiteResponseDTO>(
      `${this.apiUrl}${this.baseUrlSucursal}`,
      data
    );
  }

  crearTramiteSSRoiPN(
    data: TramiteSupersociedadesRoiDto
  ): Observable<TramiteResponseDTO> {
    return this.http.post<TramiteResponseDTO>(
      `${this.apiUrl}${this.baseUrlPN}`,
      data
    );
  }

  crearTramiteSSRoiPNNC(
    data: TramiteSupersociedadesRoiDto
  ): Observable<TramiteResponseDTO> {
    return this.http.post<TramiteResponseDTO>(
      `${this.apiUrl}${this.baseUrlPNNC}`,
      data
    );
  }

  listaRevisores(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null) {
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/revisores-fiscales?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

  eliminarRevisor(id: number) {
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-revisor?id=${id}`,
      {}
    );
  }

  listaApoderados(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null) {
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/apoderados?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

  listaRepresentantes(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/representantes-legales?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

  eliminarApoderado(id: number) {
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-apoderado?id=${id}`,
      {}
    );
  }

  listaContadores(pagina: number, codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null) {
    return this.http.get<TablaProfesionalesDTO>(
      `${this.urlProfesionales}/contadores?${pagina}&tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

  eliminarContador(id: number) {
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-contador?id=${id}`,
      {}
    );
  }

  eliminarRepresentante(id: number){
    return this.http.post<RespuestaEliminarDTO>(
      `${this.urlProfesionales}/eliminar-representante?id=${id}`,
      {}
    );
  }

  listaSimpleRevisores(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/revisores-fiscales/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

  listaSimpleApoderados(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/apoderados/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

  listaSimpleContadores(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/contadores/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }


  listaSimpleRepresentantes(codigoProceso: string, tipoSolicitante: number | undefined, idTramite: number | null){
    return this.http.get<FormFieldOption[]>(
      `${this.urlProfesionales}/representantes-legales/lista-simple?tipoTramite=${codigoProceso}&tipoSolicitante=${tipoSolicitante}&idTramite=${idTramite}`
    );
  }

}
